import { Kpi } from './Kpi';
import { ChartType } from '../../../utils/chart/SerieChartBuilder';
import { FieldValue } from "../field/FieldValue";
import { SatType } from "../SatTypeEnum";
import { DateTime } from 'luxon';
import { KpiEvolution } from "./KpiInstance";

export class SatImpactByCategoriesKpi extends Kpi {
  readonly satType: SatType;
  readonly categories: Array<FieldValue>;
  readonly tree: string;

  constructor(name: string, satType: SatType, tree: string, categories: Array<FieldValue>) {
    super(name);
    this.satType = satType;
    this.categories = categories;
    this.tree = tree;
  }

  getType() {
    return 'satImpactByCategories';
  }

  getLabel(kpiInstance, t) {
    return this._i18n(t, 'kpi.satImpactByCategories.label');
  }

  getNumber(kpiInstance, t) {
    return this._number(t, kpiInstance.data.value);
  }

  getLegend(kpiInstance, t) {
    return this._i18n(t, 'kpi.satImpactByCategories.legend');
  }

  getEvolution(kpiInstance, t): KpiEvolution {

    return {
      type: ChartType.TIME_LINE,
      yAxis: {
        autoAdapted: { min:-100, max:100 },
        tickLabelCallback: (value) => {
          return this._number(t, value);
        }
      },
      data: kpiInstance.data.evolution.map(e => ({ x: DateTime.fromMillis(e.date).toJSDate(), y: e.value })),
      tooltipRenderer: (value) => {
        return this._number(t, value);
      }
    };
  }

  getApiParams() {
    return {
      satType: this.satType.name,
      tree: this.tree,
      categories: this.categories.map(c => c.fullName)
    };
  }

  private _number(t, value) {
    return this._i18n(t, 'kpi.satImpactByCategories.number',
        {context: value < 0 ? 'negative' : 'positive', count: value});
  }

  private _i18n(t, key, obj = {}) {
    return t(key, {...obj, satType: this.satType.getAliasedName()});
  }
}